import jwtDecode from "jwt-decode";

interface MainRolesRoutes {
    [key: string | number]: any;
}

const rolesCodes: any = {
    0: 'Sales Assistant',
    1: 'giftee',
    2: 'gifter'
}

const mainRolesRoutes: MainRolesRoutes = {
    giftee: 'giftee',
    gifter: 'gifter',
};
const isJwtExpired = (token: any) => {
    if (typeof(token) !== 'string' || !token) {
        console.log('invalid token provided');
        return true;
    }

    let isJwtExpired = false;
    const { exp }: any = jwtDecode(token);
    const currentTime = new Date().getTime() / 1000;

    if (currentTime > exp) isJwtExpired = true;

    return isJwtExpired;
}

const checkPathName = (pathname: string, token: string) => {
    let user: any = jwtDecode(token);
    let userRoleCode = user.role;
    let userRole = rolesCodes[userRoleCode];
    let userRoleRoute = mainRolesRoutes[userRole];

    if (pathname !== userRoleRoute) {
        return false;
    }

    return true;
}
const apiBaseURL: any = process.env.REACT_APP_API_BASE_URL;
const remoteApiBaseURL: any = process.env.REACT_APP_REMOTE_API_BASE_URL;
const remoteApiAuth: any = process.env.REACT_APP_REMOTE_API_AUTH;
const frontendBaseURL: any = process.env.REACT_APP_BASE_URL;
const gifterPassword: any = process.env.REACT_APP_GIFTER_PASSWORD;

const paymentApiBaseUrl: any = process.env.REACT_APP_PAYMENT_BASE_URL;
const paymentApiAuth: any = process.env.REACT_APP_PAYMENT_AUTH;

const ga4MeasurementID: any = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const ga4DebugMode: any = process.env.REACT_APP_GA4_DEBUG_MODE;

export {rolesCodes, checkPathName, mainRolesRoutes, apiBaseURL, remoteApiBaseURL, remoteApiAuth, frontendBaseURL, gifterPassword, paymentApiBaseUrl, paymentApiAuth, isJwtExpired, ga4MeasurementID, ga4DebugMode};